// src/routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Dashboard from '../pages/Dashboard';
import Achievements from '../pages/Achievements';
import AchievementDetail from '../pages/AchievementDetail';
import Characters from '../pages/Characters';
import CharacterDetail from '../pages/CharacterDetail';
import Admin from '../pages/Admin';
import AdminAchievements from '../pages/AdminAchievements';
import AdminTranslations from '../pages/AdminTranslations';
import Login from '../pages/Login';
import AuthCallback from '../pages/AuthCallback';

import AdminRoute from './AdminRoute';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/achievements" element={<Achievements />} />
    <Route path="/achievements/:id" element={<AchievementDetail />} />
    <Route path="/characters" element={<Characters />} />
    <Route path="/characters/:id" element={<CharacterDetail />} />
    <Route path="/login" element={<Login />} />

    {/* Adminbereich */}
    <Route path="/admin" element={
      <AdminRoute>
        <Admin />
      </AdminRoute>
    } />
    <Route path="/admin/achievements" element={
      <AdminRoute>
        <AdminAchievements />
      </AdminRoute>
    } />
    <Route path="/admin/translations" element={
      <AdminRoute>
        <AdminTranslations />
      </AdminRoute>
    } />

    {/* Auth Callback (z. B. für OAuth) */}
    <Route path="/auth/callback" element={<AuthCallback />} />

    {/* Fallback */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;